import * as React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Tab, Nav, NavItem, Row, Col, Tabs } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import * as Site from '../../shared/Site';
import * as Actions from './actions/Actions';
import { IInvoiceJournal } from './Entities';
import InvoiceJournalList from './list/InvoiceJournalList';
import {getSiteName} from "../../shared/Site";

interface IInvoiceJournalModal {
    html: any;
}

interface ILegalEntity {
    id: number;
    name: string;
    numberOfNewInvoices: number;
    numberOfNewForeignInvoices: number;
    site: number;
    localInvoiceJournals: IInvoiceJournal[];
    foreignInvoiceJournals: IInvoiceJournal[];
}

interface IProps {
    invoiceJournal: IInvoiceJournalModal;
    legalEntities: ILegalEntity[];
    actions: IActions;
    site: string;
}

interface IState {
    showInvoiceJournal: boolean;
    activeKey: number;
}

class InvoiceJournalsPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showInvoiceJournal: false,
            activeKey: 0
        };

        this.viewInvoiceJournal = this.viewInvoiceJournal.bind(this);
        this.closeInvoiceJournal = this.closeInvoiceJournal.bind(this);
        this.print = this.print.bind(this);
    }

    componentDidMount() {
        this.props.actions.getList();
    }

    viewInvoiceJournal(id: number) {
        this.props.actions.view(id).then(() => {
            this.setState({ showInvoiceJournal: true } as IState);
        });
    }

    closeInvoiceJournal() {
        this.setState({ showInvoiceJournal: false } as IState);
    }

    print(): void {
        window.print();
    }

    render() {
        return (
            <div>
                <Tab.Container defaultActiveKey={0} id="uncontrolled-tab">
                    <div>
                        <Nav bsStyle="tabs">
                            {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                                <NavItem eventKey={index} key={'legal-entity-nav-item-' + index}>
                                    {`${x.name} ${
                                        x.site === Site.Scandphotos ? '- Scandphotos' : this.props.site === getSiteName(Site.Zentuvo) ? '' : '- SE360'
                                    }`}{' '}
                                    {x.numberOfNewInvoices > 0 || x.numberOfNewForeignInvoices > 0
                                        ? `(${
                                              x.numberOfNewInvoices + x.numberOfNewForeignInvoices
                                          })`
                                        : ''}
                                </NavItem>
                            ))}
                        </Nav>
                        <Tab.Content>
                            {this.props.legalEntities.map((x: ILegalEntity, index: number) => (
                                <Tab.Pane eventKey={index} key={'legal-entity-tab-' + index}>
                                    <div>
                                        <Tabs
                                            id="controlled-tab-example"
                                            activeKey={this.state.activeKey}
                                            onSelect={(key: any) =>
                                                this.setState({
                                                    activeKey: key
                                                } as IState)
                                            }
                                        >
                                            <Tab
                                                eventKey={0}
                                                title={`${Translate(
                                                    'economy/invoice-logs/tab/label/domestic'
                                                )} ${
                                                    x.numberOfNewInvoices > 0
                                                        ? '(' + x.numberOfNewInvoices + ')'
                                                        : ''
                                                }`}
                                            >
                                                <Button
                                                    onClick={() =>
                                                        this.props.actions.create(
                                                            x.id,
                                                            x.site,
                                                            false
                                                        )
                                                    }
                                                    bsStyle="success"
                                                    disabled={x.numberOfNewInvoices < 1}
                                                >
                                                    {Translate('invoice-journal/create/button', {
                                                        numberOfNewInvoices: x.numberOfNewInvoices
                                                    })}
                                                </Button>
                                                <InvoiceJournalList
                                                    list={x.localInvoiceJournals}
                                                    view={this.viewInvoiceJournal}
                                                    foreign={false}
                                                />
                                            </Tab>
                                            <Tab
                                                eventKey={1}
                                                title={`${Translate(
                                                    'economy/invoice-logs/tab/label/foreign'
                                                )} ${
                                                    x.numberOfNewForeignInvoices > 0
                                                        ? '(' + x.numberOfNewForeignInvoices + ')'
                                                        : ''
                                                }`}
                                            >
                                                <Button
                                                    onClick={() =>
                                                        this.props.actions.create(
                                                            x.id,
                                                            x.site,
                                                            true
                                                        )
                                                    }
                                                    bsStyle="success"
                                                    disabled={x.numberOfNewForeignInvoices < 1}
                                                >
                                                    {Translate('invoice-journal/create/button', {
                                                        numberOfNewInvoices:
                                                            x.numberOfNewForeignInvoices
                                                    })}
                                                </Button>
                                                <InvoiceJournalList
                                                    list={x.foreignInvoiceJournals}
                                                    view={this.viewInvoiceJournal}
                                                    foreign={true}
                                                />
                                            </Tab>
                                        </Tabs>
                                    </div>
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </div>
                </Tab.Container>

                {this.state.showInvoiceJournal && this.props.invoiceJournal && (
                    <Modal show={true} onHide={this.closeInvoiceJournal} bsSize="large">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                {Translate('invoice-journal/view/modal/title')}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="invoice-modal-row">
                                <Col xs={12} className="invoice-preview-column">
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.invoiceJournal.html
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeInvoiceJournal}>
                                {Translate('invoice-journal/view/modal/button/close')}
                            </Button>
                            {!this.state.hasError && (
                                <Button onClick={() => this.print()} bsStyle="primary">
                                    {Translate('invoice/print')}
                                </Button>
                            )}
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        invoiceJournal: state.invoiceJournal.invoiceJournal,
        legalEntities: state.invoiceJournal.legalEntities,
        site: state.site
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getList: () => dispatch(Actions.getInvoiceJournalList()),
            create: (legalEntityId: number, site: number, createForeign: boolean) =>
                dispatch(Actions.createInvoiceJournal(legalEntityId, site, createForeign)),
            view: (id: number) => dispatch(Actions.getInvoiceJournal(id))
        }
    };
}

interface IActions {
    getList: () => Promise<any>;
    create: (legalEntityId: number, site: number, createForeign: boolean) => Promise<any>;
    view: (id: number) => Promise<any>;
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceJournalsPage);
